// Where an event's games were imported from, in the tournament header. A file
// is a copy that cannot be watched, so a new version is uploaded again; a
// Google Sheet is refreshed from the sheet itself. Both go to the import
// page, which shows the diff before it writes

import { Link } from 'react-router-dom';
import moment from 'moment';
import './ScheduleSource.scss';

// Drive's times are RFC 3339 in UTC, so the order of the text is the order of
// the times. A sheet imported before its time could be read compares with the
// moment of the import instead
const sheetChanged = ({ modifiedTime, importedModifiedTime, importedAt }) => {
  if (!modifiedTime) return false;
  if (importedModifiedTime) return modifiedTime > importedModifiedTime;
  const at = importedAt?.toDate?.();
  return !!at && new Date(modifiedTime) > at;
};

export default function ScheduleSource({ id, source }) {
  const importedAt = source?.importedAt?.toDate?.();
  const isSheet = source?.kind === 'gsheet';
  const changed = isSheet && sheetChanged(source);

  return (
    <div className='schedule-source'>
      <p className='source-info'>
        <span className='gray-600 font-medium'>Schedule source: </span>
        {source ? (
          <>
            <span className='file'>
              {source.name}
              {isSheet && <span className='kind'> (Google Sheet)</span>}
            </span>
            <span className='sheet'>{source.sheet}</span>
            {importedAt && (
              <span className='imported-at'>
                imported {moment(importedAt).format('MMM D, h:mma')}
              </span>
            )}
          </>
        ) : (
          <span className='none'>no schedule imported</span>
        )}
      </p>
      {changed && <span className='badge changed-badge'>Sheet changed</span>}
      <div className='source-actions'>
        {isSheet && (
          <Link
            className={'button small' + (changed ? '' : ' bw')}
            to={`/tournaments/${id}/import?from=sheet`}
          >
            Refresh from sheet
          </Link>
        )}
        <Link className='button small bw' to={`/tournaments/${id}/import`}>
          {source ? 'Re-import' : 'Import schedule'}
        </Link>
      </div>
    </div>
  );
}
